import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation CreatePackageAssetType($companyId: ID!, $attributes: PackageAssetTypeAttributes!) {
    createPackageAssetType(companyId: $companyId, attributes: $attributes) {
       packageAssetType {
        id
        ...CreatedPackageAssetType
      }
      errors {
        path
        message
      }
    }
  }

  fragment CreatedPackageAssetType on PackageAssetType {
    id
    package {
      id
    }
    assetType {
      id
    }
    quantity
  }
`
